export const queryGetActivityObservation = `
query GetActivityObservation($activityId: String!, $itineraryType: String!) {
    getActivityObservation(activityId: $activityId, itineraryType: $itineraryType) {
        observaciones
    } 
}`;

export const mutationUpdateObservacionesActivity = `
mutation UpdateObservacionesActivity($id: String!, $observaciones: String!, $type: String!) {
    updateObservacionesActivity(id: $id, observaciones: $observaciones, type: $type) {
        id,
    } 
}`;

export const queryGetServiceObservation = `
query GetServiceObservation($serviceId: String!) {
    getServiceObservation(serviceId: $serviceId) {
        observaciones
    } 
}`;

export const mutationUpdateObservacionesService = `
mutation UpdateObservacionesService($id: String!, $observaciones: String!) {
    updateObservacionesService(id: $id, observaciones: $observaciones) {
        id,
    } 
}`;
